import { motion } from "framer-motion";
import { MaskedLine, Overline } from "@/components/Reveal";

const PageHero = ({ image, overline, lines, lede, testid }) => (
  <section
    data-testid={testid}
    className="relative flex min-h-[72vh] items-end overflow-hidden pb-20 pt-40"
  >
    {image && (
      <>
        <img
          src={image}
          alt=""
          className="absolute inset-0 h-full w-full scale-105 object-cover opacity-30 grayscale"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0B] via-[#0A0A0B]/55 to-[#0A0A0B]/35" />
      </>
    )}
    <div className="relative mx-auto w-full max-w-7xl px-6 sm:px-8 lg:px-12">
      <motion.div
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
      >
        <Overline>{overline}</Overline>
      </motion.div>
      <h1 className="mt-8 font-serif text-4xl uppercase leading-[1.05] tracking-tight text-white sm:text-5xl lg:text-6xl">
        {lines.map((line, i) => (
          <MaskedLine key={i} delay={0.15 + i * 0.14}>
            {line}
          </MaskedLine>
        ))}
      </h1>
      {lede && (
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.6, ease: [0.16, 1, 0.3, 1] }}
          className="mt-8 max-w-xl text-sm font-light leading-relaxed text-stone-400 sm:text-base"
        >
          {lede}
        </motion.p>
      )}
    </div>
  </section>
);

export default PageHero;
